<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'

import menuRoutes from '@router/menuRoutes.js'



export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      routesPax: menuRoutes.navRoutePaxTotals,
    }
  },
}
</script>

<template>
  <Layout>
    <div>
      <div
        v-if="$resize && !$mq.above(992)"
        class="alert alert-info  mt-3 ml-3 mr-3"
        role="alert"
      >
        <h4 class="text-info-darker lead mb-2"
          >Hi, looks like you're using a mobile device.</h4
        >
        <p class="mb-2"
          >Just to let you know, we're still working on some aspects of the
          mobile expirence and it's not 100% complete.
        </p>

        <small class="text-muted">Last updated: 25th Feb 2020</small>
      </div>
      <div class="card mt-3 ml-3 mr-3">
        <div class="card-body">
          <div class="col-md-8">
            <h3>Welcome to L-DCS Insight</h3>

            <p
              >The data visualisation app from Damarel Systems. You're logged in
              as <strong>{{ user.UserName }}</strong> and are connected to
              <strong>{{ user.Database }}</strong
              >.<br />
              This login is restricted to the following carrier codes:
              <b>{{ user.Carrier }}</b></p
            >
            <p>
              <a class="btn btn-primary text-white mr-2" to="/profile"
                >Profile</a
              >
              <a class="btn btn-dark text-white" to="/logout">Logout</a>
            </p>
          </div>
        </div>
      </div>

      
    </div>
  </Layout>
</template>
